import { render, staticRenderFns } from "./CompraTeam.vue?vue&type=template&id=01c94cae&"
import script from "./CompraTeam.vue?vue&type=script&lang=js&"
export * from "./CompraTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports